import { useMemo } from 'react';
import { useUiStore } from '@/store/uiStore';
import { useDataStore } from '@/store/dataStore';
import type { ScoredGeography } from '@/types/insights';

/** Resolves the currently-selected geoId to its full scored record, if any. */
export function useMapSelection(): {
  selected: ScoredGeography | null;
  compare: ScoredGeography | null;
  isDrawerOpen: boolean;
} {
  const selectedGeoId = useUiStore((s) => s.selectedGeoId);
  const compareGeoId = useUiStore((s) => s.compareGeoId);
  const isDrawerOpen = useUiStore((s) => s.isDrawerOpen);
  const geographies = useDataStore((s) => s.geographies);

  const selected = useMemo(
    () => geographies.find((g) => g.record.geoId === selectedGeoId) ?? null,
    [geographies, selectedGeoId],
  );
  const compare = useMemo(
    () => geographies.find((g) => g.record.geoId === compareGeoId) ?? null,
    [geographies, compareGeoId],
  );

  return { selected, compare, isDrawerOpen };
}
